import { render, staticRenderFns } from "./root.vue?vue&type=template&id=5f4556df&scoped=true&"
import script from "./root.js?vue&type=script&lang=js&"
export * from "./root.js?vue&type=script&lang=js&"
import style0 from "./root.scss?vue&type=style&index=0&id=5f4556df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4556df",
  null
  
)

export default component.exports